// extracted by mini-css-extract-plugin
export default {"container":"AuthorsInput_container__SNkNS","authorsList":"AuthorsInput_authorsList__hg+sG","author":"AuthorsInput_author__oPZOk","authorsIpnut":"AuthorsInput_authorsIpnut__-qSjZ"};